import { REHYDRATE } from "redux-persist";
import update from "immutability-helper";
import {
    COMPANY_LAB_LIST_FETCH_BEGIN,
    COMPANY_LAB_LIST_FETCH_SUCCESS,
    COMPANY_LAB_LIST_FETCH_FAIL,
    COMPANY_BUYER_LIST_FETCH_BEGIN,
    COMPANY_BUYER_LIST_FETCH_SUCCESS,
    COMPANY_BUYER_LIST_FETCH_FAIL,
    COMPANY_SUPPLIER_LIST_FETCH_BEGIN,
    COMPANY_SUPPLIER_LIST_FETCH_SUCCESS,
    COMPANY_SUPPLIER_LIST_FETCH_FAIL,
} from "actions/companyActions";
import {
    SUPPLIER_FAVORITE_TOGGLE_SUCCESS,
    SUPPLIER_CLASSIFICATION_CHANGE_SUCCESS,
    SUPPLIER_MANAGER_RESET,
} from "views/SupplierManager/types";
import { ANY_FIELD_UPDATE, updatedObject } from "actions/formActions";

const INITIAL_STATE = {
    labs: { data: [], status: "idle" },
    buyers: { data: [], status: "idle" },
    suppliers: { data: [], noOfPages: 1, status: "idle" },
};

export default function companiesReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case REHYDRATE:
            return state;

        case ANY_FIELD_UPDATE:
            if (action.storeName !== "companies") return state;

            return updatedObject(state, action.accessPath, action.newVal);

        case COMPANY_LAB_LIST_FETCH_BEGIN:
            return { ...state, labs: { data: [], status: "fetching" } };

        case COMPANY_LAB_LIST_FETCH_SUCCESS:
            return { ...state, labs: { data: action.data, status: "idle" } };

        case COMPANY_LAB_LIST_FETCH_FAIL:
            return { ...state, labs: { data: [], status: "failed", failReason: action.reason } };

        case COMPANY_SUPPLIER_LIST_FETCH_BEGIN:
            return { ...state, suppliers: { data: state.suppliers.data, status: "fetching" } };

        case COMPANY_SUPPLIER_LIST_FETCH_SUCCESS:
            return {
                ...state,
                suppliers: {
                    data: action.data.suppliers,
                    noOfPages: action.data.noOfPages,
                    status: "idle",
                },
            };

        case COMPANY_SUPPLIER_LIST_FETCH_FAIL:
            return {
                ...state,
                suppliers: { data: [], status: "failed", failReason: action.reason },
            };

        case COMPANY_BUYER_LIST_FETCH_BEGIN:
            return { ...state, buyers: { data: [], status: "fetching" } };

        case COMPANY_BUYER_LIST_FETCH_SUCCESS:
            return {
                ...state,
                buyers: {
                    data: action.data.buyers,
                    noOfPages: action.data.noOfPages,
                    status: "idle",
                },
            };

        case COMPANY_BUYER_LIST_FETCH_FAIL:
            return { ...state, buyers: { data: [], status: "failed", failReason: action.reason } };

        case SUPPLIER_MANAGER_RESET:
            return update(state, {
                suppliers: {
                    $set: { data: [], noOfPages: 1, status: "idle" },
                },
            });

        case SUPPLIER_FAVORITE_TOGGLE_SUCCESS:
            return update(state, {
                suppliers: {
                    data: {
                        [action.supplierIdx]: {
                            $apply: supplier => ({
                                ...supplier,
                                isBookmarked: !supplier.isBookmarked,
                            }),
                        },
                    },
                },
            });

        case SUPPLIER_CLASSIFICATION_CHANGE_SUCCESS:
            return update(state, {
                suppliers: {
                    data: {
                        [action.supplierIdx]: {
                            $apply: supplier => ({
                                ...supplier,
                                classification: action.classification,
                            }),
                        },
                    },
                },
            });

        default:
            return state;
    }
}
